export default {
  errorDefault: 'An error has occurred',
  unknown: 'Unknown',
};
